import { MarketingNav } from './MarketingNav';
export default MarketingNav;